
const def = {
  map: 'Map',
  data: 'Data',
  barchartCurrent: 'Current',
  barchartFuture: 'Future',
  headerTitle: 'Know Your Neighborhood',
  ctaBannerText: 'Unlock 15,000+ data variables and additional analysis tools',
  ctaButtonText: 'Learn More',
  widgetZero: 'Drive Times: ',
  widgetOne: 'Tapestry Segmentation',
  widgetTwo: 'Annual Spending Habits',
  widgetThree: 'Disposable Income',
  widgetFour: 'Demographic Population',
  dtWidgetTitle: 'Drive Time:',
  dtUnits: 'miles',
  dtUnitsLabel: 'miles',
  creditLabel: 'Credit Debt',
  apparelLabel: 'Apparel',
  medicalLabel: 'Medical Insurance',
  entertainementLabel: 'Entertainment',
  medianAge: 'Median Age',
  housholdSize: 'Household Size',
  diversityIdx: 'Diversity Index',
  tapestryInfo:
    'Esri’s Tapestry Segmentation classifies U.S. neighborhoods into 67 unique segments based not only on demographics but also socioeconomic characteristics.',
  habitsInfo:
    'Esri\'s Consumer Spending database provides unique details about the products and services that consumers are buying.',
  incomeInfo:
    'Esri’s Demographics include household income, per capita income, income by age, disposable income, net worth, percent of income for mortgage, and wealth index.',
  populationInfo:
    'Esri\'s Demographics include current-year estimates and 5-year forecasts of U.S. demographic data.',
  minutes: 'Minutes',
  defaultDtMessage: 'Select a ZIP Code',
  splashTitle: 'Know Your Neighborhood',
  splashSubTitle:
    'What can location intelligence reveal about your neighborhood? Let\'s find out!',
  splashBody:
    'Enter a ZIP code to unlock information about the populations in your neighborhood, including common behaviors, spending habits, and disposable income.',
  splashMobileBody:
    'Enter a ZIP code to find out what location intelligence can reveal about your neighborhood.',
  rotateScreen: 'Please rotate screen to view app',
  searchPlaceHolder: 'Enter ZIP Code',
  searchError: 'Unable to find matching ZIP code'
};

const esriStrings = window.__esriStrings
  ? {...window.__esriStrings}
  : {...def};
export default {...esriStrings};
